import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

export const schemaDE = yup.object().shape({
  amount: yup
    .string()
    .required('benötigt')
    .test(
      'requestedAmountMin',
      'Geben Sie einen Betrag ab 1.000€ an',
      (value) => {
        const numericValue = currencyToNumber(value, {
          currencySymbol: true,
          locale: 'de-DE',
          minorUnits: false,
        });
        if (!numericValue) return false;
        return numericValue >= 1000;
      },
    )
    .test(
      'requestedAmountMax',
      'Geben Sie einen Betrag bis max. 500.000€ an',
      (value) => {
        const numericValue = currencyToNumber(value, {
          currencySymbol: true,
          locale: 'de-DE',
          minorUnits: false,
        });
        if (!numericValue) return false;
        return numericValue <= 500000;
      },
    ),
});
